import {Box, DSIconButton, DSIconMisc} from "@cdx/ds";
import {VisionBoardId} from "../../cdx-models/VisionBoard";
import {TooltipForChild} from "@cdx/common";
import {useInstance} from "../../lib/mate/mate-utils";
import {useLocation} from "react-router";

type Props = {
  lastVisitedBoards: VisionBoardId[];
  activeVisionBoardSeq: number | null;
};
const VisionBoardHeaderIcon = ({lastVisitedBoards, activeVisionBoardSeq}: Props) => {
  const lastBoard = useInstance("visionBoard", lastVisitedBoards[0]);
  const location = useLocation();
  if (!lastBoard) return null;

  const getLink = () => {
    if (activeVisionBoardSeq) {
      const qs = new URLSearchParams(location.search);
      qs.delete("visionBoard");
      return {...location, search: qs.toString()};
    } else {
      return `?visionBoard=${lastBoard.accountSeq}`;
    }
  };

  return (
    <Box pl="2px" pb="2px">
      <TooltipForChild
        tooltip={
          <Box px="8px" py="4px">
            Open Vision Board for <b>{lastBoard.card.title}</b>
          </Box>
        }
      >
        <DSIconButton
          icon={<DSIconMisc />}
          variant="secondary"
          to={getLink()}
          active={Boolean(activeVisionBoardSeq)}
        />
      </TooltipForChild>
    </Box>
  );
};

export default VisionBoardHeaderIcon;
